module.exports = __webpack_public_path__ + "static/EnmTX_BosGodMartial_L_A_cl-2c3567f7187eb578bab5795f08e45e95.gif";